import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';
import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import {PromocracyLogo} from "_components/PromocracyLogo/PromocracyLogo";
import PageFlow from "_pages/__routes/PageFlow";
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';
import {PageBackgroundImages} from "_components/PageBackgroundImages/PageBackgroundImages";

//import { executeAction } from "__globals/appActions";
import * as GC from "__globals/GLOBAL-CONSTANTS";
import { logIt } from '__globals/global-functions';


export const AlreadyWon = props => {

	logIt( GC.PAGE_ALREADY_WON + " PAGE IS CALLED", null, false );

	//const dispatch = useDispatch();

	const promotion = useSelector(state => state.promotion);
	//logIt( "PROMOTION at " + GC.PAGE_ALREADY_WON, promotion, true );

	// LOCAL VARIABLES
	const [action, setAction] = useState('');
	const [value, setValue] = useState('');

	const [goNext, setGoNext] = useState(false);

	const doAction = ( a, v ) => {
		if ( a.toUpperCase().trim() === GC.ACTION_NAVIGATE ) {
			setAction(a);
			setValue(v);
			setGoNext(true);
		} else {
			//dispatch( executeAction(a, v) );
		}
	}

	if (goNext) {

		return (<PageFlow page={GC.PAGE_ALREADY_WON} error={null} action={action} value={value} />);

	} else {

		return (
			<React.Fragment>
				<TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title}/>
				<div id="already_won_page">

					<table>
						<tbody>
						<tr>
							<td className="page-visual">

								<PageBackgroundImages
									promotion={promotion}
									pageKey={"already-won"}
								/>

							</td>
							<td className="page-content">

								<div id='already_won_content'>

									<PageCopy
										promotion={promotion}
										configKey={"alreadyWon"}
										jsonKey={GC.PAGE_ALREADY_WON}
									/>

									<ActionButtons
										promotion={promotion}
										configKey={"alreadyWon"}
										jsonKey={GC.PAGE_ALREADY_WON}
										doAction={doAction}
									/>


								</div>

								<PromocracyLogo promotion={promotion} />

							</td>
						</tr>
						</tbody>
					</table>

					<CustomContent/>

				</div>
			</React.Fragment>

		);

	}

}

